module.exports = __webpack_public_path__ + "img/title01_solgan.a607d8d3.png";